import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Analytics from './Analytics';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Reports & Analytics | Admin',
    component: (
      <AdminLayout>
        <Analytics />
      </AdminLayout>
    ),
  };
}

export default action;
